import React from 'react';
import { S as Skeleton } from './Skeleton-RKr5mJai.js';

const CartItemDrawerSkeleton = () => (React.createElement("div", { className: "cart-item" },
    React.createElement("div", { className: "image" },
        React.createElement("div", { className: "img", style: { paddingBottom: 11 } },
            React.createElement(Skeleton, { width: 100, height: 70, marginBottom: 0 }))),
    React.createElement("div", { className: "inner-wrapper" },
        React.createElement("div", { className: "description", style: { display: 'flex', alignItems: 'center' } },
            React.createElement(Skeleton, { width: "50%" })),
        React.createElement("div", { className: "inner-wrapper" },
            React.createElement("div", { className: "quantity" },
                React.createElement(Skeleton, { width: 60 })),
            React.createElement("div", { className: "price" },
                React.createElement(Skeleton, { width: 60 }))))));

export { CartItemDrawerSkeleton as C };
//# sourceMappingURL=CartItemDrawerSkeleton-pSF-OxYE.js.map
